import clsx from "clsx"

import { Badge } from "@atoms"

import GroupLabel from "@molecules/GroupLabel/GroupLabel"

import styles from "./SelectListGroupLabel.module.scss"
import { SelectListGroupLabelProps } from "./SelectListGroupLabel.types"

export default function SelectListGroupLabel(props: SelectListGroupLabelProps) {
    const { title, showTitle = true, showBadge, badge, isLoading = false, className, ...rest } = props

    const suffixSlot =
        showBadge && badge ? (
            <Badge size="sm" variant="default">
                {badge}
            </Badge>
        ) : null

    const label = showTitle ? title : ""

    return (
        <div className={clsx(styles.base, className)} {...rest}>
            <GroupLabel
                variant="primary"
                label={label}
                showMiddleSlot={false}
                suffixSlot={suffixSlot}
                isCollapsible={false}
                isLoading={isLoading}
            />
        </div>
    )
}
